import ReactDOM from 'react-dom/client';
import { Suspense, StrictMode } from 'react';
import { BrowserRouter } from 'react-router';
import { HelmetProvider } from 'react-helmet-async';
import AgoraRTC, { AgoraRTCProvider } from 'agora-rtc-react';
import App from './App';


// ----------------------------------------------------------------------

AgoraRTC.setLogLevel(4);  
const client = AgoraRTC.createClient({ 
  mode: 'rtc', 
  codec: 'vp8'
});

const originalConsoleError = console.error;
console.error = (...args) => {
  const message = args[0];
  if (typeof message === 'string' && (
    message.includes('statscollector-1.agora.io') ||
    message.includes('statscollector.sd-rtn.com') ||
    message.includes('ERR_CONNECTION_REFUSED')
  )) {
    return;
  }
  originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  // <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Suspense>
          <AgoraRTCProvider client={client}>
            <App />
          </AgoraRTCProvider>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  // </StrictMode>
);
